import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { reduxKey } from './constants';
import { createPollRequest, createPollSuccess, updatePollRequest, updatePollSuccess, requestFailure } from './actions';
const defaultState = {
    isSubmitting: false
};
// createPollSuccess is fired by the saga just before redirecting to the
// browse posts feed. While the browser is loading, the reducer for that
// action keeps the submit button disabled by artifically continuing the
// appearance that it's still submitting.
//
// If redirection UX changes, keep in mind the isSubmitting flag.
const actionHandlers = {
    [createPollRequest.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: true
        }),
    [createPollSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: true
        }),
    [updatePollRequest.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: true
        }),
    [updatePollSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: false
        }),
    [requestFailure.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isSubmitting: false
        })
};
const reducers = {
    [reduxKey]: (state = defaultState, action)=>{
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    }
};
export default reducers;
